var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.145 7.93751L9.32331 4.11585C9.08881 3.88146 8.77081 3.74983 8.43926 3.74991C8.10771 3.74999 7.78978 3.88177 7.55539 4.11626C7.32101 4.35076 7.18938 4.66876 7.18945 5.00031C7.18953 5.33186 7.32131 5.6498 7.55581 5.88418L11.3775 9.70501C11.4163 9.74372 11.4471 9.7897 11.4681 9.84032C11.4891 9.89094 11.4999 9.94521 11.4999 10C11.4999 10.0548 11.4891 10.1091 11.4681 10.1597C11.4471 10.2103 11.4163 10.2563 11.3775 10.295L7.55581 14.1158C7.32131 14.3502 7.18953 14.6682 7.18945 14.9997C7.18938 15.3313 7.32101 15.6493 7.55539 15.8838C7.78978 16.1183 8.10771 16.25 8.43926 16.2501C8.77081 16.2502 9.08881 16.1186 9.32331 15.8842L13.145 12.0625C13.691 11.515 13.9976 10.7733 13.9976 10C13.9976 9.22675 13.691 8.48504 13.145 7.93751Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.38c419e5812d6a3e485bdc5bc392598d.svg";
export { ForwardRef as ReactComponent };